import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Generates a full sharing URL from a path (e.g. /assessment/abc123).
 * Uses window.location.origin in the browser, or falls back to env/base URL.
 */
export function generateSharingUrl(path) {
  const base =
    (typeof window !== 'undefined' && window.location?.origin) ||
    process.env.REACT_APP_PUBLIC_URL ||
    process.env.PUBLIC_URL ||
    '';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}
